export default "__VITE_ASSET__DFIzF9Bz__"